<template>
  <div class="header">
    <div class="plate left">
      <!-- <img src="../assets/logo.png"/> -->
      <img :src="libraryInfo.logo"/>
      {{dateTime}} {{nowTime}}{{week}}</div>
    <div class="title">{{title}}</div>
    <div class="plate right">{{city}}{{wea}}{{tem}}°C</div>
  </div>
</template>

<script>
  const axios = require('axios');
  export default {
    props:{
      title:{
        type:String,
        default:''
      }
    },
    data(){
      return{
        dateTime:'',
        nowTime:'',
        week:'',
        city:'',
        tem:'',
        wea:'',
        libraryInfo:{}
      }
    },
    mounted() {
      this.libraryInfo = JSON.parse(sessionStorage.getItem("libraryInfo"));
      let myDate = new Date()
      let year = myDate.getFullYear();//年
      let month = myDate.getMonth() + 1;//注意！月份是从0月开始获取的，所以要+1;
      let day = myDate.getDate();//日
      let wk = myDate.getDay()
      let weeks = ['星期日', '星期一', '星期二', '星期三', '星期四', '星期五', '星期六']

      let _this = this;
      _this.dateTime = year+'年'+month+'月'+day+'日'+' '
      _this.week = weeks[wk]
      _this.nowTimes()
      _this.getwea()
      },
    methods:{
      timeFormate(timeStamp) {
        let myDate = new Date()
        let _this = this;
        let hh = myDate.getHours();
        let mf = myDate.getMinutes()<10 ? '0'+myDate.getMinutes() : myDate.getMinutes();
        let ss = myDate.getSeconds()<10 ? '0'+myDate.getSeconds() : myDate.getSeconds();  　　
        _this.nowTime = hh+":"+mf+':'+ss+" " ;
      },
      nowTimes(){
        this.timeFormate(new Date());
        setInterval(this.nowTimes,1000);
        this.clear()
      },
      clear(){
            clearInterval(this.nowTimes)
            this.nowTimes = null;
      },
      getwea(){ //获取天气
      
      var cityCode = this.libraryInfo.regionCode;
        axios({
                 method: 'get',
                // url:'https://restapi.amap.com/v3/weather/weatherInfo?'+this.libraryInfo.remarks
                  url:'https://restapi.amap.com/v3/weather/weatherInfo?city='+cityCode+'&key=baf7fb85b381d34f309ff218a9e644d9'
                }).then((response) => {
                    console.log(response);//查看接口返回的数据
                    this.wea=response.data.lives[0].weather+' ';//天气
                    this.tem=response.data.lives[0].temperature;//温度
                    this.city=response.data.lives[0].city+' ';
                    }, function(response) {
                    console.log("错误信息：" + response)
                });
                }
    },
    beforeDestroy(){
      this.clear()
    }
  }
</script>

<style>
  .header{
    width: 100%;
    height: 117px;
    background: url(../../static/headerbg.png) no-repeat;
    background-size: 100% 100%;
    display: flex;
    padding: 0 100 0 30px;
    justify-content: space-between;
  }
  .plate{
    font-size: 30px;
    color: #FFFFFF;
    margin-top: 29px;
    flex: 4;
  }
  .plate img{
    width: 68px;
    height: 68px;
    float: left;
    margin-top: -16px;
    margin-right: 40px;
    margin-left: 19px;
  }
  .left{text-align: left;}
  .right{text-align: right;}
  .title{
    font-size: 45px;
    font-weight: bold;
    color: #FFFFFF;
    text-align: center;
    flex: 5;
    margin-top: 27px;
  }
  .title img{
    width: 64px;
    height: 64px;
    vertical-align: -12px;
    margin-right: 4px;
  }
</style>



// WEBPACK FOOTER //
// src/components/headers.vue